export default __webpack_public_path__ + "static/media/Mask Group 144.f088ddc7.svg";